export function generateLocalId(): string {
  const cryptoObj = globalThis.crypto;

  if (cryptoObj && typeof cryptoObj.randomUUID === 'function') {
    return cryptoObj.randomUUID();
  }

  if (cryptoObj && typeof cryptoObj.getRandomValues === 'function') {
    const bytes = new Uint8Array(8);
    cryptoObj.getRandomValues(bytes);
    let hex = '';
    for (const byte of bytes) {
      hex += byte.toString(16).padStart(2, '0');
    }
    return `${Date.now()}-${hex}`;
  }

  // Last-resort fallback for environments without the Web Crypto API.
  // Unreachable in any supported browser; kept only so the function is total.
  const perf = typeof globalThis.performance !== 'undefined' ? globalThis.performance.now() : 0;
  return `${Date.now()}-${perf.toString(36).replace('.', '')}`;
}
